jQuery(document).ready(function($) {
      $(document).ready(function() {
       // Listen for change event on the country dropdown
       $('select#countryDropdown').on('change', function() {
           var getSelectedValue = $('select#countryDropdown').val();
           console.log(getSelectedValue); // Log the selected value to the console
           
           // Hide both sections initially
           $('#usaSection').hide();
           $('#canadaSection').hide();

           // Check if the selected value is 'usa' or 'canada' and display the corresponding section
           if (getSelectedValue === 'usa') {
               $('#usaSection').show(); // Show USA section
           } else if (getSelectedValue === 'canada') {
               $('#canadaSection').show(); // Show Canada section
           }
       });
   });


    // setTimeout(function() {
        const pageTitle = localStorage.getItem('pageTitle');
        
        if (pageTitle) {
            const selectElement = $('#select-cause option');

            if ($('#select-cause').length) {
                console.log('Dropdown found!');
                
                const pageTitleWords = pageTitle.toLowerCase().split(/\s+/); 
                let exactMatchFound = false;

                jQuery(selectElement).each(function() {
                    const optionValue = jQuery(this).val().toLowerCase();
                    console.log('Checking option:', optionValue);
                    
                    // Check for exact match first (strict match of all words)
                    const isExactMatch = pageTitleWords.every(word => optionValue === word); 

                    if (isExactMatch) {
                        jQuery(this).prop('selected', true);
                        console.log("Exact match selected: ", jQuery(this).val());
                        exactMatchFound = true; // Mark as exact match found
                        return false; // Stop the loop as we found the match
                    }
                });

                // If no exact match, fall back to partial match
                if (!exactMatchFound) {
                    jQuery(selectElement).each(function() {
                        const optionValue = jQuery(this).val().toLowerCase();
                        console.log('Checking option for partial match:', optionValue);
                        
                        // Check for partial match (pageTitle words should be part of the option value)
                        const isPartialMatch = pageTitleWords.some(word => optionValue.includes(word));
                        
                        if (isPartialMatch) {
                            jQuery(this).prop('selected', true);
                            console.log("Partial match selected: ", jQuery(this).val());
                            return false; // Stop the loop after selecting a match
                        }
                    });
                }

                // Clean up pageTitle from localStorage
                localStorage.removeItem('pageTitle');
            } else {
                console.log('Dropdown not found!');
            }
        } else {
            console.log("No pageTitle found in localStorage.");
        }
    // }, 50); 
});


	
	
	$('.main-project-slider').slick({
	dots: false,
	arrow:true,
	infinite: true,
	speed: 300,
	centerMode: true,
	centerPadding:'200px',
	slidesToShow: 3,
	slidesToScroll: 3,
	prevArrow:'<button class="slick-prev"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_100_97)"><path d="M24.0173 32.738C24.2893 32.738 24.5676 32.6305 24.7763 32.4218C25.1937 32.0044 25.1937 31.3213 24.7763 30.9039L10.4889 16.6164L24.5676 2.53773C24.985 2.1203 24.985 1.43723 24.5676 1.0198C24.1502 0.602375 23.4671 0.602375 23.0497 1.0198L8.20565 15.8575C7.78822 16.2749 7.78822 16.958 8.20565 17.3754L23.252 32.4218C23.4671 32.6368 23.739 32.738 24.0173 32.738Z" fill="white"/></g><defs><clipPath id="clip0_100_97"><rect width="32.3823" height="32.3823" fill="white" transform="matrix(0 -1 1 0 0.255615 32.9973)"/></clipPath></defs></svg></button>',
	nextArrow:'<button class="slick-next"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_100_95)"><path d="M8.82694 32.738C8.55498 32.738 8.27666 32.6305 8.06795 32.4218C7.65052 32.0044 7.65052 31.3213 8.06795 30.9039L22.3554 16.6164L8.27666 2.53773C7.85923 2.1203 7.85923 1.43723 8.27666 1.0198C8.69409 0.602375 9.37715 0.602375 9.79458 1.0198L24.6386 15.8575C25.056 16.2749 25.056 16.958 24.6386 17.3754L9.59219 32.4218C9.37715 32.6368 9.10522 32.738 8.82694 32.738Z" fill="white"/></g><defs><clipPath id="clip0_100_95"><rect width="32.3823" height="32.3823" fill="white" transform="matrix(0 -1 -1 0 32.5886 32.9973)"/></clipPath></defs></svg> </button>',
	responsive: [
		{
		breakpoint: 1024,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: true,
			dots: false
		}
		},
		{
		breakpoint: 600,
		settings: {
			slidesToShow: 1,
        infinite: true,
      centerPadding:'0px',
			slidesToScroll: 1
		}
		},
			{
		breakpoint: 767,
		settings: {
			slidesToShow: 2,
        infinite: true,
      centerPadding:'0px',
			slidesToScroll: 1
		}
		},
		{
		breakpoint: 480,
		settings: {
			slidesToShow: 1,
        infinite: true,
        centerPadding:'0px',
			slidesToScroll: 1
		}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
	});

	$('.testimonial-slider').slick({
	dots: false,
	arrow:true,
	infinite: true,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 3,
	prevArrow:'<button class="slick-prev"> <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_100_97)"><path d="M24.0173 32.738C24.2893 32.738 24.5676 32.6305 24.7763 32.4218C25.1937 32.0044 25.1937 31.3213 24.7763 30.9039L10.4889 16.6164L24.5676 2.53773C24.985 2.1203 24.985 1.43723 24.5676 1.0198C24.1502 0.602375 23.4671 0.602375 23.0497 1.0198L8.20565 15.8575C7.78822 16.2749 7.78822 16.958 8.20565 17.3754L23.252 32.4218C23.4671 32.6368 23.739 32.738 24.0173 32.738Z" fill="white"/></g><defs><clipPath id="clip0_100_97"><rect width="32.3823" height="32.3823" fill="white" transform="matrix(0 -1 1 0 0.255615 32.9973)"/></clipPath></defs></svg></button>',
	nextArrow:'<button class="slick-next"> <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_100_95)"><path d="M8.82694 32.738C8.55498 32.738 8.27666 32.6305 8.06795 32.4218C7.65052 32.0044 7.65052 31.3213 8.06795 30.9039L22.3554 16.6164L8.27666 2.53773C7.85923 2.1203 7.85923 1.43723 8.27666 1.0198C8.69409 0.602375 9.37715 0.602375 9.79458 1.0198L24.6386 15.8575C25.056 16.2749 25.056 16.958 24.6386 17.3754L9.59219 32.4218C9.37715 32.6368 9.10522 32.738 8.82694 32.738Z" fill="white"/></g><defs><clipPath id="clip0_100_95"><rect width="32.3823" height="32.3823" fill="white" transform="matrix(0 -1 -1 0 32.5886 32.9973)"/></clipPath></defs></svg> </button>',
	responsive: [
		{
		breakpoint: 1024,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: true,
			dots: false
		}
		},
		{
		breakpoint: 600,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		}
		},
		{
		breakpoint: 767,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		}
		},
		{
		breakpoint: 480,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
	});



document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.Current-project .progress-bar-wrapper');
  const fill = wrapper.querySelector('.Current-project .progress-fill');
  const text = fill.querySelector('.Current-project .progress-text');
  const targetPercent = parseFloat(fill.getAttribute('data-percent'));

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateProgress(targetPercent);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });

  observer.observe(wrapper);

  function animateProgress(target) {
    const duration = 2000; // 2 seconds
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // Clamp to [0,1]
      const currentPercent = progress * target;

      fill.style.width = currentPercent + '%';
      text.textContent = currentPercent.toFixed(1) + '%';

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }
});

    function animateValue(el, start, end, duration) {
      let startTime = null;

      function step(currentTime) {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        el.textContent = Math.floor(progress * (end - start) + start).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const numbers = entry.target.querySelectorAll('.impact-number');
          numbers.forEach(num => {
            const target = +num.getAttribute('data-target');
            animateValue(num, 0, target, 2000); // animate over 2 seconds
          });
          observer.unobserve(entry.target); // run animation only once
        }
      });
    }, { threshold: 0.3 });

    observer.observe(document.querySelector('.impact-section'));

document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('#boardTabs button');
  const bannerImg = document.querySelector('.banner-img');
  const bannerTitle = document.querySelector('.banner-title');
  const bannerSubtitle = document.querySelector('.banner-subtitle');

  tabButtons.forEach(function(button, index) {
    button.addEventListener('click', function () {
      // === 1. Update Banner Section ===
      const image = this.getAttribute('data-banner-image');
      const title = this.getAttribute('data-banner-title');
      const subtitle = this.getAttribute('data-banner-subtitle');

      if (image) bannerImg.setAttribute('src', image);
      if (title) bannerTitle.textContent = title;
      if (subtitle) bannerSubtitle.textContent = subtitle;

      // === 2. Show/Hide Team Sections ===
      document.querySelectorAll('.HAF-Canada-Team').forEach(function(section) {
        section.style.display = 'none';
      });

      const activeTeamSection = document.getElementById('team-section-' + index);
      if (activeTeamSection) {
        activeTeamSection.style.display = 'block';
      }
    });
  });
});
// -------------------------------------------------------------------------------------------------------------------

// document.getElementById('donate-button').addEventListener('click', function() {
//     // const pageTitle = document.title;  // Get the page title directly
//     console.log("hello");
//     // sessionStorage.setItem('pageTitle', pageTitle);  // Store it in sessionStorage
// });


//   document.addEventListener("DOMContentLoaded", function () {
//     const pageTitle = sessionStorage.getItem('pageTitle');

//     const selectElement = document.getElementById('select-cause');

//     function getFirstTwoWords(str) {
//       return str.split(' ').slice(0, 2).join(' ');  
//     }

//     if (pageTitle) {
//       const firstTwoWords = getFirstTwoWords(pageTitle); 
//       for (let i = 0; i < selectElement.options.length; i++) {
//         const option = selectElement.options[i];
//         const optionValue = option.value;

//         if (optionValue.includes(firstTwoWords)) {
//           selectElement.selectedIndex = i; 
//           break;
//         }
//       }
//       sessionStorage.removeItem('pageTitle');
//     }
//   });



  // Ensure the first option is selected by default when the page loads
  window.onload = function() {
    const dropdown = document.getElementById('countryDropdown');
    dropdown.selectedIndex = 0; // Set the first option as selected
    const firstOption = dropdown.options[0];
    firstOption.setAttribute('selected', 'selected'); // Ensure the first option has the 'selected' attribute
  };

  // Listen for a change in the select element
  document.getElementById('countryDropdown').addEventListener('change', function() {
    // Remove the 'selected' attribute from all options first
    const options = this.querySelectorAll('option');
    options.forEach(option => option.removeAttribute('selected'));

    // Add the 'selected' attribute to the currently selected option
    const selectedOption = this.options[this.selectedIndex];
    selectedOption.setAttribute('selected', 'selected');
  });



